import React from 'react';
import Input from './Input';
import Date from './Date';
import Radio from './Radio';
import File from './File';

const FormikControl = (props) => {
    
   switch(props.control){
    case "input" :
        return (
            <Input {...props}/>
        )
        break;
         case "date" :
        return (
            <Date  {...props}/>
        )
        break;
        case  "radio" : 
        return( <Radio {...props} />)
        break;
        case  "file" : 
        return( <File {...props} />)
        break;

        default: return null;
   }
}

export default FormikControl;
